export const GET_TRANSACTION = 'CDL_INDIVIDUAL/get_transaction';
export const APPROVE_TRANSACTION = 'CDL_INDIVIDUAL/approve_transaction';
export const UPDATE_TRANSACTION = 'CDL_INDIVIDUAL/update_transaction';
export const SHOW_TRANSACTION = 'CDL_INDIVIDUAL/show_transaction';
export const START_ASSESSMENT = 'CDL_INDIVIDUAL/start_assessment';
export const GET_SETTINGS = 'CDL_INDIVIDUAL/get_settings';
export const UPDATE_TEST_STATUS = 'CDL_INDIVIDUAL/update_health_status';
export const CEDULA_URI =
  'api/v1/administrators/transaction_histories/cedula/{id}/generate';
export const TAG_AS_PRINTED_TRANSACTION = 'CDL_INDIVIDUAL/tag_as_printed';
export const ASSESS_RECEIPT = 'BIRTH_CERTIFICATES/assess_receipt';
export const OR_CHECK = 'CDL_INDIVIDUAL/or_check';
export const UPDATE_CDL = 'CDL_INDIVIDUAL/update_cdl';
export const GET_INSTITUTION = 'CDL_INDIVIDUAL/get_institution';
export const GET_WORK_DESCRIPTION = 'CDL_INDIVIDUAL/get_description';
export const GET_CITIZENSHIP = 'CDL_INDIVIDUAL/get_citizenship';
export const REGENERATE_CEDULA_URI =
  'api/v1/administrators/transaction_histories/cedula/{id}/regenerate';
export const UPDATE_AMOUNT = 'CDL_INDIVIDUAL/update_amount';

export const GET_REGION = 'CDL_INDIVIDUAL/get_regions';
export const GET_PROVINCE = 'CDL_INDIVIDUAL/get_provinces';
export const GET_MUNICIPALITIES = 'CDL_INDIVIDUAL/get_municipalities';
export const GET_BARANGAYS = 'CDL_INDIVIDUAL/get_barangays';

export const GENERATE_OR_URI = 
'api/v1/administrators/transaction_histories/cedula/{id}/view_eor';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
};

export const BUSINESS_FORM = {
  business_establishment_id: '',
  business_establishments: '',
  business_establishments_address: '',
  number_of_additional_copy: '',
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];

export const GENDER = [
  {
    label: 'MALE',
    value: 'MALE',
  },
  {
    label: 'FEMALE',
    value: 'FEMALE',
  },
];

export const CIVIL_STATUS = [
  {
    label: 'SINGLE',
    value: 'SINGLE',
  },
  {
    label: 'MARRIED',
    value: 'MARRIED',
  },
  {
    label: 'DIVORCED',
    value: 'DIVORCED',
  },
  {
    label: 'WIDOWED',
    value: 'WIDOWED',
  },
];

export const VALID_IDS = [
  {
    label: 'PASSPORT',
    value: 'PASSPORT',
  },
  {
    label: 'SSS',
    value: 'SSS',
  },
  {
    label: 'UMID',
    value: 'UMID',
  },
  {
    label: 'PHILHEALTH',
    value: 'PHILHEALTH',
  },
  {
    label: "DRIVER's LICENSE",
    value: "DRIVER's LICENSE",
  },
  {
    label: "VOTER's ID",
    value: "VOTER's ID",
  },
  {
    label: "SENIOR CITIZEN's ID",
    value: "SENIOR CITIZEN's ID",
  },
  {
    label: 'POSTAL ID',
    value: 'POSTAL ID',
  },
  {
    label: 'BARANGAY ID',
    value: 'BARANGAY ID',
  },
  {
    label: 'Authorization Letter',
    value: 'Authorization Letter',
  },
];

export const CEDULA_EDIT_FORM = {
  first_name: '',
  middle_name: '',
  last_name: '',
  tax_payer_account_number: '',

  gender: '',
  civil_status: '',
  citizenship_code: 'PHL',
  acr_number: '',
  birth_date: '',
  profession_code: '',
  profession_other: '',
  height: 0,
  weight: 0,
  residence_tax_due: '',

  is_employed_individual: 0,
  additional_residence_tax_1: 0,
  additional_residence_tax_2: 0,
  additional_residence_tax_3: 0,
  additional_residence_tax_cedula_1: 0,
  additional_residence_tax_cedula_2: 0,
  additional_residence_tax_cedula_3: 0,
  region_code: '',
  province_code: '',
  municipality_code: '',
  barangay_code: '',
  street: '',

  place_of_birth_region_code: '',
  place_of_birth_province_code: '',
  place_of_birth_municipality_code: '',
  extension_name: '',
  payment_receipt_image_url: '',
  valid_id_to_present: '',
};
